import React from 'react';
import { useNavigate } from 'react-router-dom';
import eImg from '../../../img/Casung1.jpeg';
import jImg from '../../../img/Casung2.jpeg';
import lImg from '../../../img/Casung3.jpeg';
import mImg from '../../../img/Casung4.jpeg';
import nImg from '../../../img/Casung5.jpeg';
import oImg from '../../../img/Casung6.jpeg';
import pImg from '../../../img/Casung7.jpeg';

const ProductsCasung = () => {
  const navigate = useNavigate();

  const casungProducts = [
    {
      moldingNumber: "CA001",
      description: "Moldura clásica con un diseño atemporal, perfecta para marcos de puertas.",
      imagen: eImg
    },
    {
      moldingNumber: "CA002",
      description: "Moldura moderna con líneas limpias y un acabado elegante para espacios contemporáneos.",
      imagen: jImg
    },
    {
      moldingNumber: "CA003",
      description: "Moldura decorativa con detalles intrincados para agregar un toque único a cualquier habitación.",
      imagen: lImg
    },
    {
      moldingNumber: "CA004",
      description: "Moldura rústica con un acabado en madera natural, ideal para interiores acogedores.",
      imagen: mImg
    },
    {
      moldingNumber: "CA005",
      description: "Moldura minimalista con un perfil sutil que se integra perfectamente con diseños modernos.",
      imagen: nImg
    },
    {
      moldingNumber: "CA006",
      description: "Moldura de lujo con una excelente artesanía para proyectos de alta gama.",
      imagen: oImg
    },
    {
      moldingNumber: "CA007",
      description: "Moldura versátil adecuada para varios estilos de puertas y ventanas.",
      imagen: pImg
    }
  ];

  const handleContactClick = () => {
    navigate('/es/contact');
  };

  return (
    <div className="container mx-auto px-4 py-28">
      <h1 className="text-3xl font-bold text-center mb-9 font-montserrat">Colección de Molduras</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {casungProducts.map((product) => (
          <div
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full"
            key={product.moldingNumber}
          >
            <img
              src={product.imagen}
              alt={`Moldura ${product.moldingNumber}`}
              className="w-full h-48 object-cover"
            />
            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold text-gray-800 mb-2">
                Moldura {product.moldingNumber}
              </h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                {product.description}
              </p>
            </div>
          </div>
        ))}

        {/* Tarjeta Informativa */}
        <div
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
          <div>
            <h5 className="text-xl font-bold text-emerald-50 mb-4">¿Necesitas más información?</h5>
            <p className="text-emerald-100 mb-4">
              ¿Interesado en nuestras molduras? ¿Quieres discutir diseños personalizados o solicitar una cotización? 
              Nuestro equipo está listo para ayudarte a encontrar la moldura perfecta para tu proyecto.
            </p>
            <p className="text-emerald-100">
              Para ver la lista completa de productos, por favor regístrate para obtener tu token de acceso (clave).
            </p>
          </div>
          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contáctanos →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsCasung;
